// extracted by css-extract-rspack-plugin
export default {"title":"_25cf7370","link":"_13341130","imageXLarge":"_1845e6d2","artOneLine":"_940c8c3d","noCreator":"_77985c8d","ellipsis":"_d0d20f05"};